export const HeadingStyling = {
  baseStyle: {
    textTransform: "uppercase",
    marginBottom: "4"
  },
  defaultProps: {
    size: "lg",
  },
};
